<template>
  <div class="edit">
    <v-container
      fluid
      class="px-0"
      v-for="(row, index) in fieldsRow"
      :key="index"
    >
      <v-row>
        <v-col
          v-for="(field, cIndex) in row.fields"
          :key="cIndex"
          v-bind="field.colProps || row.colsProp"
          class="py-0"
        >
          <component
            :is="field.component"
            v-model="localValue[field.id]"
            v-bind="field.props"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Entity } from '@/mixins';
import MachineViewer from './viewer';

export default {
  mixins: [Entity],

  components: {
    MachineViewer
  },

  computed: {
    fieldsRow() {
      return [
        {
          fields: [
            {
              id: 'machines',
              component: 'MachineViewer'
            }
          ]
        }
      ];
    }
  }
};
</script>
